import { render, staticRenderFns } from "./m-template-upload.vue?vue&type=template&id=1cba21aa&scoped=true&lang=pug"
import script from "./m-template-upload.vue?vue&type=script&lang=js"
export * from "./m-template-upload.vue?vue&type=script&lang=js"
import style0 from "./m-template-upload.vue?vue&type=style&index=0&id=1cba21aa&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cba21aa",
  null
  
)

export default component.exports